import * as React from "react";

import BODebounceInput from "app/components/BOComponents/BODebounceInput";

import AllUsersContainer from "app/components/AppComponents/Users/AllUsersContainer";

type State = {
  search: string;
};

export default class List extends React.Component<any, State> {
  state = {
    search: ""
  };

  componentDidMount() {
    this.props.setHeader({
      title: "Ops > Users",
      description: "SnapScan users"
    });
  }

  render() {
    return (
      <section className="padded">
        <div
          style={{
            display: "flex",
            justifyContent: "flex-start"
          }}
        >
          <BODebounceInput
            minLength={2}
            debounceTimeout={300}
            value={this.state.search}
            placeholder="Search Users"
            onChange={search => {
              this.setState({ search });
            }}
          />
        </div>
        <AllUsersContainer name={"ops.users.list"} search={this.state.search} />
      </section>
    );
  }
}
